import React from "react";
import { RootState } from "@/store/redux/store";
import { useSelector } from "react-redux";
import styled from "styled-components";

const Row = () => {

    const mode = useSelector((state: RootState) => state.mapScreen.mapMode);
    const date = useSelector((state: RootState) => state.mapScreen.date);
    const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'numeric', year: 'numeric' };
    const formattedDate = new Date(date).toLocaleDateString('ru-RU', options);
    const dateInfo = `на дату ${formattedDate}`
    const isToday = new Date(date).getDate() === new Date().getDate();

    return (
        <Container>
            <Routes>{`Маршруты по расписанию ${dateInfo}`}</Routes>
            <ContainerArrivalAndDepartureTime>
                {isToday &&
                    <ArrivalAndDepartureTime>Прогноз онлайн</ArrivalAndDepartureTime>}
                {/* <ArrivalAndDepartureTimeForecast>Прогноз</ArrivalAndDepartureTimeForecast> */}
            </ContainerArrivalAndDepartureTime>
        </Container>
    )
}

export default Row;

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 15px;
    `

const Routes = styled.p`
    color: #9DA3B5;
    font-size: 15px;
    margin: 0;
    text-align: left;
    `
const ArrivalAndDepartureTime = styled.p`
    color: #9DA3B5;
    font-size: 12px;
    margin:0;
    border-radius: 14px;
    font-weight: 500;
     white-space: nowrap;        
    overflow: hidden;          
    text-overflow: ellipsis;
    `

const ArrivalAndDepartureTimeForecast = styled.p`
    color: #9DA3B5;
    font-size: 10px;
    margin:0;
    font-weight: 500;
    white-space: nowrap;        
    overflow: hidden;          
    text-overflow: ellipsis;
    text-align: right;
    `

const ContainerArrivalAndDepartureTime = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    `